import { render, staticRenderFns } from "./verMiAnuncio.vue?vue&type=template&id=85d311be&scoped=true"
import script from "./verMiAnuncio.vue?vue&type=script&lang=js"
export * from "./verMiAnuncio.vue?vue&type=script&lang=js"
import style0 from "./verMiAnuncio.vue?vue&type=style&index=0&id=85d311be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d311be",
  null
  
)

export default component.exports